<div class="reports-container">
  <div class="page-header">
    <h2>Access Management Reports</h2>
    <p class="muted">Aggregate metrics across invitations, top inviters, and groups.</p>
  </div>

  @if (summaryResource.value(); as summary) {
    <section class="summary-section">
      <div class="summary-header">
        <h3>Invitations Overview</h3>
        <div class="summary-actions">
          <small class="muted">Generated {{ formatDateTime(summary.generatedAt) }}</small>
          <p-button
            icon="pi pi-refresh"
            severity="secondary"
            pTooltip="Refresh summary"
            tooltipPosition="top"
            [text]="true"
            [rounded]="true"
            [loading]="summaryResource.isLoading()"
            (onClick)="refreshSummary()"
          ></p-button>
        </div>
      </div>

      <div class="summary-totals">
        <div class="summary-stat">
          <span class="stat-label">Total Invitations</span>
          <span class="stat-value">{{ summary.totalInvitations }}</span>
        </div>
        <div class="summary-stat">
          <span class="stat-label">Pending</span>
          <span class="stat-value">{{ summary.byStatus.pending }}</span>
        </div>
        <div class="summary-stat warn-stat">
          <span class="stat-label">Pending But Time-Expired</span>
          <span class="stat-value">{{ summary.pendingButTimeExpiredCount }}</span>
        </div>
        <div class="summary-stat">
          <span class="stat-label">Accepted</span>
          <span class="stat-value">{{ summary.byStatus.accepted }}</span>
        </div>
        <div class="summary-stat">
          <span class="stat-label">Declined</span>
          <span class="stat-value">{{ summary.byStatus.declined }}</span>
        </div>
        <div class="summary-stat">
          <span class="stat-label">Expired</span>
          <span class="stat-value">{{ summary.byStatus.expired }}</span>
        </div>
        <div class="summary-stat">
          <span class="stat-label">Pending Purchase</span>
          <span class="stat-value">{{ summary.byStatus.pendingPurchase }}</span>
        </div>
      </div>

      <div class="summary-grid">
        <div class="summary-card">
          <h4>Recent Activity</h4>
          <table class="activity-table">
            <thead>
              <tr>
                <th scope="col">Window</th>
                <th scope="col">Created</th>
                <th scope="col">Accepted</th>
                <th scope="col">Declined</th>
                <th scope="col">Expired</th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <th scope="row">Last 7 days</th>
                <td>{{ summary.recentActivity.last7Days.created }}</td>
                <td>{{ summary.recentActivity.last7Days.accepted }}</td>
                <td>{{ summary.recentActivity.last7Days.declined }}</td>
                <td>{{ summary.recentActivity.last7Days.expired }}</td>
              </tr>
              <tr>
                <th scope="row">Last 30 days</th>
                <td>{{ summary.recentActivity.last30Days.created }}</td>
                <td>{{ summary.recentActivity.last30Days.accepted }}</td>
                <td>{{ summary.recentActivity.last30Days.declined }}</td>
                <td>{{ summary.recentActivity.last30Days.expired }}</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="summary-card">
          <h4>Top Inviters</h4>
          @if (summary.topInviters.length > 0) {
            <ul class="rank-list">
              @for (inviter of summary.topInviters; track inviter.inviterUserId) {
                <li>
                  <span class="rank-name" [pTooltip]="inviter.inviterEmail || ''" tooltipPosition="top">
                    {{ inviter.inviterName || inviter.inviterEmail || inviter.inviterUserId }}
                  </span>
                  <span class="rank-stats">
                    <span class="rank-total">{{ inviter.totalInvitationsSent }}</span>
                    @if (inviter.acceptanceRatePercent !== null && inviter.acceptanceRatePercent !== undefined) {
                      <small class="muted">{{ inviter.acceptanceRatePercent }}% accepted</small>
                    }
                  </span>
                </li>
              }
            </ul>
          } @else {
            <small class="muted">No inviter activity yet.</small>
          }
        </div>

        <div class="summary-card">
          <h4>By Group</h4>
          @if (summary.byGroup.length > 0) {
            <ul class="rank-list">
              @for (group of summary.byGroup; track group.groupId) {
                <li>
                  <span class="rank-name" [pTooltip]="group.groupId" tooltipPosition="top">
                    {{ group.groupName || group.groupId }}
                  </span>
                  <span class="rank-stats">
                    <span class="rank-total">{{ group.totalInvitations }}</span>
                    <small class="muted">{{ group.pendingCount }} pending / {{ group.acceptedCount }} accepted</small>
                  </span>
                </li>
              }
            </ul>
          } @else {
            <small class="muted">No group activity yet.</small>
          }
        </div>
      </div>
    </section>
  } @else if (summaryResource.isLoading()) {
    <div class="summary-loading">
      <p-progressSpinner [style]="{ width: '32px', height: '32px' }"></p-progressSpinner>
      <small>Loading summary…</small>
    </div>
  } @else if (summaryResource.error()) {
    <div class="summary-error">
      <i class="pi pi-exclamation-triangle"></i>
      <span>Failed to load summary.</span>
      <p-button label="Retry" severity="secondary" [text]="true" (onClick)="refreshSummary()"></p-button>
    </div>
  }
</div>
